import { gql } from "@apollo/client";

export const CREATE_VIDEO_MEET_CHAT_ROOM = gql`
mutation createChatRoomForVideoMeet($attenteeId: UUID!, $meetId: UUID!) {
  createChatRoomForVideoMeet(attenteeId: $attenteeId, meetId: $meetId)
}`;

export const GET_VIDEO_MEET_CHAT_ROOM = gql`
query getVideoMeetChatroomId($meetId: UUID!) {
  allVideoMeetChats(
    filter: {meetId: {equalTo: $meetId}, deletedAt: {isNull: true}}
    orderBy: CREATED_AT_DESC
    first: 1
  ) {
    nodes {
      meetId
      chatroomId
      vmId
    }
    totalCount
  }
}
`

export const ADD_USER_TO_VIDEO_CHAT_ROOM = gql`
mutation addUserToVideoMeetChatroom($attenteeId: UUID!, $chatroomId: UUID!) {
  addUserToVideoMeetChatroom(attenteeId: $attenteeId, chatroomId: $chatroomId)
}`


export const GET_UNREAD_MESSAGES_COUNT_FOR_VIDEO_MEET = gql`
query getUnreadMessagesForVideoChat($attenteeId: UUID!, $chatroomId: UUID!) {
  getUnreadMessagesForVideoChat(attenteeId: $attenteeId, chatroomId: $chatroomId)
}
`